interface PageMainTitle {
  category: string
  title: string
  sub_title: string
  sub_title2: string
  text: string
  text2?: string
}

export const pageMainTitle: PageMainTitle = {
  category: 'ダウンロード',
  title: 'Download',
  sub_title: '',
  sub_title2: '',
  text: '私たちのノウハウや業界別の事例など、提供するサービスについて詳細にまとめた資料になります。ぜひご一読ください。',
}
